module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/duplicate-b4d5da5602f34cd9968fccc7ef5c19ba.svg";